// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')

const bem = BemEntity('SearchDomainHeader')

function SearchDomainHeader(props) {
  return React.createElement('div', {
    className: bem.block()
  },
    'Posts from ',
    React.createElement('a', {
      className: bem.element('domain'),
      href: `http://${props.domain}`,
      rel: 'nofollow',
      target: '_blank'
    },
      props.domain
    )
  )
}

SearchDomainHeader.propTypes = {
  domain: PropTypes.string.isRequired
}

module.exports = SearchDomainHeader
